/* Mr Gains — Premium Mobile Menu behaviour (vanilla JS, init-once) */
(function(){
  if(window.__mgmmInit){return;} window.__mgmmInit=true;
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    var panel=document.getElementById('mgmm-panel');
    var scrim=document.getElementById('mgmm-scrim');
    if(!panel){return;}
    var lastFocus=null;
    function focusables(){ return panel.querySelectorAll('a[href],button:not([disabled]),input,select,[tabindex]:not([tabindex="-1"])'); }
    function openMenu(){
      lastFocus=document.activeElement;
      panel.classList.add('is-open'); panel.style.transform='translateX(0)'; panel.style.visibility='visible';
      if(scrim){ scrim.hidden=false; scrim.classList.add('is-open'); }
      document.body.style.overflow='hidden'; panel.setAttribute('aria-hidden','false');
      var f=focusables(); if(f.length){ f[0].focus(); }
      syncCart();
    }
    function closeMenu(){
      panel.classList.remove('is-open'); panel.style.transform=''; panel.style.visibility='';
      if(scrim){ scrim.classList.remove('is-open'); }
      document.body.style.overflow=''; panel.setAttribute('aria-hidden','true');
      if(lastFocus&&lastFocus.focus){ lastFocus.focus(); }
    }
    function toggleAcc(acc){
      var isOpen=acc.classList.contains('is-open');
      panel.querySelectorAll('.mgmm-acc.is-open').forEach(function(a){ if(a!==acc){ a.classList.remove('is-open'); var h=a.querySelector('.mgmm-acc-head'); if(h){h.setAttribute('aria-expanded','false');} } });
      acc.classList.toggle('is-open',!isOpen);
      var head=acc.querySelector('.mgmm-acc-head'); if(head){ head.setAttribute('aria-expanded',String(!isOpen)); }
    }
    function onTap(e){
      var t=e.target; if(!t||!t.closest){return;}
      if(t.closest('[data-menu-open]')){ e.preventDefault(); openMenu(); return; }
      if(t.closest('[data-mgmm-close]')){ e.preventDefault(); closeMenu(); return; }
      if(scrim&&t===scrim){ closeMenu(); return; }
      var accHead=t.closest('.mgmm-acc-head'); if(accHead){ e.preventDefault(); toggleAcc(accHead.parentNode); return; }
      var link=t.closest('.mgmm a[href]'); if(link){ closeMenu(); }
    }
    document.addEventListener('click',onTap,false);
    document.addEventListener('touchend',function(e){ var t=e.target; if(t&&t.closest&&t.closest('[data-menu-open]')){ e.preventDefault(); openMenu(); } },{passive:false});
    document.addEventListener('keydown',function(e){
      if(!panel.classList.contains('is-open')){return;}
      if(e.key==='Escape'){ closeMenu(); }
      else if(e.key==='Tab'){ var f=focusables(); if(!f.length){return;} var first=f[0],last=f[f.length-1];
        if(e.shiftKey&&document.activeElement===first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey&&document.activeElement===last){ e.preventDefault(); first.focus(); } }
    });
    function syncCart(){
      fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
        document.querySelectorAll('[data-mgmm-cart-count]').forEach(function(el){ el.textContent=c.item_count; el.style.display=c.item_count>0?'flex':'none'; });
      }).catch(function(){});
    }
    var input=panel.querySelector('[data-mgmm-search]');
    var out=panel.querySelector('[data-mgmm-suggest]');
    var timer;
    if(input&&out){
      input.addEventListener('input',function(){
        clearTimeout(timer); var q=input.value.trim();
        if(q.length<2){ out.classList.remove('is-open'); out.innerHTML=''; return; }
        timer=setTimeout(function(){ suggest(q); },220);
      });
    }
    function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
    function suggest(q){
      var url='/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url,{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(d){
        var res=(d.resources&&d.resources.results)||{};
        var products=res.products||[], collections=res.collections||[], pages=res.pages||[];
        var html='';
        products.forEach(function(p){
          var img=(p.featured_image&&p.featured_image.url)?('<img src="'+esc(p.featured_image.url)+'" alt="" loading="lazy">'):'<span class="mgmm-noimg"></span>';
          var price=p.price?('<span class="p">'+esc(p.price)+'</span>'):'';
          html+='<li><a href="'+esc(p.url)+'">'+img+'<span><span class="t">'+esc(p.title)+'</span>'+price+'</span></a></li>';
        });
        collections.forEach(function(c){ html+='<li><a href="'+esc(c.url)+'"><span class="mgmm-noimg"></span><span class="t">'+esc(c.title)+'</span></a></li>'; });
        pages.forEach(function(pg){ html+='<li><a href="'+esc(pg.url)+'"><span class="mgmm-noimg"></span><span class="t">'+esc(pg.title)+'</span></a></li>'; });
        out.innerHTML=html; out.classList.toggle('is-open',html.length>0);
      }).catch(function(){});
    }
  });
})();
